// @ts-nocheck
import axios from "axios";
import Vue from "vue";
import ElementUI from 'element-ui';

// const testToken = ''

axios.defaults.timeout = window.ipConfig.AXIOS_TIMEOUT;
axios.defaults.baseURL = window.ipConfig.BASE_URL;
// axios.defaults.baseURL = "https://yxzhhz.net/api";
// axios.defaults.baseURL = "http://192.168.0.82:8282/";

var _token = localStorage.getItem("_token") || undefined;
// console.log(_token);

// 请求拦截
axios.interceptors.request.use(
    (config) => {
        if (_token) {
            config.headers.authorization = `Bearer ${_token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// 响应拦截
axios.interceptors.response.use(
    (response) => {
        // 文件导出
        if (response.status == 200 && response.request.responseType == 'blob') {
            return response
        }
        // 图片文件
        if (response.status == 200 && response.headers['content-type'] && response.headers['content-type'].indexOf('image') != -1) {
            return response
        }
        // xxljob
        if (response.config.url.indexOf('xxl-job-admin') >= 0) {
            return response.data;
        }
        // ...
        const code = response.data.code
        if (code === 200 || code === "SUCCESS") {
            return response.data.data;
        } else if (code === 1011006 || code === 1011007 || code === 1011008 || code === 1011009) {
            // 去登陆
            ElementUI.Notification.error(
                {
                    title: '提示',
                    message: '重新登陆'
                }
            );
            http.setToken()
            setTimeout(() => {
                window.location.reload()
            }, 1000)
        } else {
            if (response.data.message) {
                console.error(`${response.data.code} --> ${response.data.message}`);
                ElementUI.Message.error(response.data.message);
                return Promise.reject(response.data);
            } else {
                console.error(`${response.data.code} --> ${response.data.msg}`);
                ElementUI.Message.error(response.data.msg);
                return Promise.reject(response.data);
            }

        }
    },
    (error) => {
        console.log('error' + error)
        return Promise.reject(error);
    }
);

const http = {
    // 封装get请求
    get(url, params = {}) {
        return new Promise((resolve, reject) => {
            axios
                .get(url, {
                    params: params,
                })
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    // 封装post请求
    post(url, data = {}, config) {
        return new Promise((resolve, reject) => {
            axios
                .post(url, data, config)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    setToken(token) {
        if (token) {
            _token = decodeURI(token);
            localStorage.setItem("_token", token);
        } else {
            _token = undefined;
            localStorage.removeItem("_token");
        }
    },
    baseURL() {
        return axios.defaults.baseURL;
    }
};

export default http;



// WEBPACK FOOTER //
// ./src/api/http.js